// Shared between the hero's scroll choreography (writer) and the 3D scene (reader).
// Positions and sizes are in screen pixels.
export const blobState = {
  visible: false,
  x: 0,
  y: 0,
  radius: 0,
  gulp: 0, // set to 1 when a letter is swallowed; the scene eases it back to 0
  lookX: -1, // where the eyes look, -1..1
  lookY: 0,
};
